module.exports = __webpack_public_path__ + "static/media/wk-withdraw.f9dbcb53.svg";